import en from '../../../assets/i18n/locales/en.json';
import fr from '../../../assets/i18n/locales/fr.json';
import nl from '../../../assets/i18n/locales/nl.json';

export const supportedLanguages = ['en', 'fr', 'nl'] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];
export type TranslationDictionary = typeof en;
export type TranslationKey = keyof TranslationDictionary & string;
export type TranslationParams = Record<string, string | number>;

export const translations: Record<SupportedLanguage, TranslationDictionary> = {
  en,
  fr,
  nl
};
